import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "@/assets/scss/index.scss"
import { API } from "./services/api";

import { CONFIG } from "./conf";
import { COOKIE } from "./plugins/cookie";

Vue.use(CONFIG);
Vue.use(COOKIE);
Vue.use(ElementUI);
Vue.use(API);
Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
}).$mount('#app')
